<template>
  <v-dialog v-model="show" persistent max-width="350">
    <v-card>
      <v-card-title>Create bulk container type</v-card-title>
      <v-divider/>
        <v-form v-model="valid" immediate ref="form">
          <v-container class="mt-4">
            <v-row>
              <v-col>
                <v-text-field label="Name" v-model="type.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" outlined dense :counter="100"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <decimal-number-input label="Capacity" v-model="type.capacity" integer prefix="" suffix="litres" :precision="0"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="show=false;$emit('input',false)">Cancel</v-btn>
        <v-btn color="primary" @click="create()">Create</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'InventoryBulkContainersTypesQuickCreate',
	props: {
    value: {type:Boolean,required:true},
  },
  data() {
    return {
      valid: true,
      show: false,
      type: {name:'',capacity:200}
    }
  },
  watch: {
    value() {
      this.type.name = '';
      this.show = this.value;
    }
  },
  methods: {
    async create() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      const results = await this.$apiCall(`mutation InventoryBulkContainersTypesQuickCreate($input: BulkContainerTypeInput!) {
                                            bulkContainerTypeCreate(input:$input) {id,name}
                                          }`,
                                          {input:this.type});
      if (!results.error) {
        this.show = false;
        this.$emit('input', false);
        this.$emit('create',results.data.bulkContainerTypeCreate);
      }
    },
  }
}
</script>
